<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择产品"
      class="product-select"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        method="post"
        url="materials/pageList">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="关键词">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="materialName" label="产品名称"/>
      <el-table-column prop="materialNO" label="产品型号" width="120px"/>
      <el-table-column prop="variableName" label="产品类别"/>
      <el-table-column label="操作" align="center" width="90px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";


  export default {
    name:"ProductSelect",
    components: {VmTable,VmSearch},
    data() {
      return {
        dialogVisible: false,
        filter: {
          filter: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>